// constants

import { string } from "yup";
import { UserActionTypes } from "./constants";

export interface UserActionType {
  type:
    | UserActionTypes.API_RESPONSE_SUCCESS
    | UserActionTypes.API_RESPONSE_ERROR
    | UserActionTypes.GET_USER_DATA
    | UserActionTypes.UPDATE_DEVICE_COUNT
    | UserActionTypes.UPDATE_DEVICE_COUNT_GLOBALLY
    | UserActionTypes.UPDATE_USER_STATUS;

  payload: {} | string;
}

// interface Users {
//   id: string;
//   experience: string;
//   users: string;
//   courses: string;
// }

// common success
export const UsersApiResponseSuccess = (
  actionType: string,
  data: any | {}
): UserActionType => ({
  type: UserActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const UsersDataApiResponseError = (
  actionType: string,
  error: string
): UserActionType => ({
  type: UserActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getUserData = (type: string): UserActionType => ({
  type: UserActionTypes.GET_USER_DATA,
  payload: { type },
});

export const updateDeviceCount = (
  userId: string,
  count: number,
  filter: string
): UserActionType => ({
  type: UserActionTypes.UPDATE_DEVICE_COUNT,
  payload: { userId, count, filter },
});

export const updateUserStatus = (
  id: string,
  value: boolean
): UserActionType => ({
  type: UserActionTypes.UPDATE_USER_STATUS,
  payload: { id, value },
});

export const updateDeviceCountGlobally = (
  filter: any,
  value: any,
): UserActionType => ({
  type: UserActionTypes.UPDATE_DEVICE_COUNT_GLOBALLY,
  payload: { value, filter },
});
